export default __webpack_public_path__ + "static/cafe_36020-386c116979ab919bcee7d1ef5d661dde.png";